import { useEffect, useRef } from 'react';
import { useWorkspace } from '@/app/providers/workspace-provider';
import { nowLocalDateTime } from '@/lib/clock';
import {
  notificationKey,
  selectDueReminders,
  showDesktopNotification,
} from './browser-notifications';
import { useAllSupervisorReminders } from './use-reminders';

/** 網站開啟期間掃描的間隔。第一版不做背景通知。 */
const SCAN_INTERVAL_MS = 60_000;

/**
 * 網站開啟期間掃描到期提醒並顯示桌面通知（spec 15.2）。
 * 通知失敗完全不影響站內提醒的狀態。
 */
export function useNotificationScanner(onOpenTask?: (taskId: string) => void): void {
  const { settings } = useWorkspace();
  const reminders = useAllSupervisorReminders();
  const notified = useRef(new Set<string>());

  const enabled = settings?.browserNotificationsEnabled ?? false;

  useEffect(() => {
    if (!enabled || !reminders) return;

    const scan = () => {
      const due = selectDueReminders(reminders, nowLocalDateTime(), notified.current);
      for (const reminder of due) {
        showDesktopNotification({
          title: '該提醒主管了',
          body: reminder.message,
          tag: reminder.id,
          ...(onOpenTask ? { onClick: () => onOpenTask(reminder.taskId) } : {}),
        });
        // 不論有沒有真的跳出來都記下，避免同一分鐘重複嘗試。
        notified.current.add(notificationKey(reminder));
      }
    };

    scan();
    const timer = setInterval(scan, SCAN_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [enabled, reminders, onOpenTask]);
}
